export default __webpack_public_path__ + "static/media/sd-page.6d9de08f.png";